import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FilterBarComponent } from '@modules/filters/filter-bar/filter-bar.component';

@Component({
  selector: 'pxc-attachment-filters',
  imports: [FilterBarComponent, TranslocoDirective],
  templateUrl: './attachment-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentFiltersComponent {}
